module.exports = __webpack_public_path__ + "img/16.6165aa0a.jpg";